import PixagriApplication from '../../models/PixagriApplications';
import { BaseApiService } from './BaseApiService';

export class BaseWagoNestApiService extends BaseApiService {
  getApplication(): PixagriApplication {
    return PixagriApplication.WAGO_API;
  }

}
